import $ from 'jquery';
import { debounce } from 'lodash';

import { jax } from '~/api/core/legacy';

import { subscribeOn } from '~/state/bridge';
import TargetingClient from '~/state/Targeting/client';
import CampaignClient from '~/state/Campaign/client';
import AgentsClient from '~/state/Agents/client';

import { render, querySubscription } from '~/theseus';
import AgentLanding from '~/theseus/components/AgentLanding';
import Navbar from '~/theseus/components/Navbar';
import AdPreview from '~/theseus/components/AdPreview';

import analyzeLink from './shared/analyze';
import { renderCreative } from './shared/creatives';
import {
  lb,
  prompt_leave,
  close_lb,
  lb_cust_img,
} from './shared/lightbox';
import { init } from './shared/login';

import { generateMultiPreview, validateAtLeastTwoSearches } from './components/ad-preview';
import getCreatives from './components/getCreatives';
import {
  publishControls,
  add_tag,
  post_ad,
  get_server_url,
  checkLinkType,
} from './components/common';

import {
  addSmallWarning,
  getSmallImages,
  isSmall,
  resetSmallWarning,
  isInstagramAd,
} from './lib/instagram';

const LINK_TYPE = 'multi_search';

let link = null;
let repost = null;
let mr = false;
let link_to_market_reports = false;
let mr_link = null;
let past_main_creatives = [];
const past_sub_creatives = [];
const repost_links = [];
const searches = [];
const shadow_searches = [];
const shadow_doms = [];
const ref_main_creative = [''];
let main_keys = null;
let field_divs = {};
let criteria = {};
let lookup = {};
const override_lookup = { alert_status: { ACTIVE: 'Active', __GRAY__: 'Under Contract', SOLD: 'Sold' } };
let ad_name = '';
let past_templates = 'none';
let past_templates_original_link = '';
let $active;

const sub_creative_markup = `
  <div class='creative-item' style='display: -webkit-box; display: -webkit-flex; display: -ms-flexbox; display: flex;'>
    <div class='creative-item__img-col'>
      <div class='creative-item__thumbnail'>
        <img />
      </div>
      <button class='creative-item__cust-img'>Use Custom Image</button>
      <button class='creative-item__clear-cust hide'>Clear Custom Image</button>
    </div>
    <form action='' class='creative-item__edit-creatives'>
      <div class='creative-item__row'>
        <input class='creative-item__first-sub can-add-tags' type='text' placeholder='First Line'>
        <p class='creative-item__first-preview'></p>
      </div>
      <div class='creative-item__row'>
        <input class='creative-item__second-sub can-add-tags' type='text' placeholder='Second Line'>
        <p class='creative-item__second-preview'></p>
      </div>
      <div class='creative-item__row creative-item__desc'>
        <p class='creative-item__original_link-preview'></p>
        <p class='creative-item__description-preview'></p>
      </div>
    </form>
    <div class='creative-item__options'>
      <button class='creative-item__clear-creative'>Clear Lines</button>
      <button class='creative-item__use-creative'>Use Lines Below</button>
      <button class='creative-item__remove-item'>Remove From Ad</button>
    </div>
  </div>
`;

let account_id = null;
let page_id = null;

querySubscription('account_id', (id) => { account_id = id; });
querySubscription('page_id', (id) => { page_id = id; });

wire_keyup($('.main-creative__field'), $('.main-creative__preview'), () => ({
  ref_creative: ref_main_creative,
  key_values: criteria,
}));

$('.main-creative__field').on('focus', () => {
  if (past_templates == 'main') { return; }
  add_fields(main_keys, criteria);
  past_templates = 'main';
  $('.past-templates__container').hide();
  $('.past-templates__container').empty();
  past_main_creatives.forEach((v) => {
    const $item = $(`<div class='past-templates__item'>${v.markedup}</div>`);
    $('.past-templates__container').append($item);
    $('.past-templates__container').slideDown('fast');
    $item.on('click', () => {
      $('.main-creative__field').val(v.template);
      $('.main-creative__field').focus();
      $('.main-creative__field').trigger('keyup');
    });
  });
});

function wire_keyup($i, $p, get_model) {
  $i.on('keyup', debounce(() => {
    const model = get_model();
    model.ref_creative[0] = $i.val();
    renderCreative({
      creative_text: model.ref_creative[0],
      key_values: model.key_values,
      lookup,
      override_lookup,
    })
      .then((r) => {
        $p.html(r.markedup);
      })
      .catch(err => console.error('render error in multi: ', err));
  }, 20));
  const input = $i.get(0);
  let p = null;
  $p.on('mouseenter', 'span', function () {
    p = input.selectionStart;
    $i.addClass('field--preview');
    if ($(this).hasClass('not-found')) $i.addClass('field--preview-not-found');
    input.focus();
    input.setSelectionRange($(this).attr('data-start'), $(this).attr('data-stop'));
    if ($(this).attr('data-field') in field_divs) {
      field_divs[$(this).attr('data-field')].addClass('available-fields__item--preview');
    }
  });
  $p.on('mouseleave', 'span', function () {
    $i.removeClass('field--preview field--preview-not-found');
    if ($(this).attr('data-field') in field_divs) {
      field_divs[$(this).attr('data-field')].removeClass('available-fields__item--preview');
    }
    if (p != null) {
      input.setSelectionRange(p, p);
    }
  });
  $p.on('click', 'span', function (e) {
    const model = get_model();
    const v = model.ref_creative[0];
    const start = parseInt($(this).attr('data-start'), 10);
    const stop = parseInt($(this).attr('data-stop'), 10);
    let replacement = $(e.target).html();
    if ($(this).hasClass('not-found')) replacement = '';
    $i.removeClass('field--preview field--preview-not-found');
    if ($(this).attr('data-field') in field_divs) {
      field_divs[$(this).attr('data-field')].removeClass('available-fields__item--preview');
    }
    model.ref_creative[0] = v.substring(0, start) + replacement + v.substring(stop);
    $i.val(model.ref_creative[0]);
    const new_p = start + replacement.length;
    $i.focus();
    $i.trigger('keyup');
    input.setSelectionRange(new_p, new_p);
  });
}

$('.link__add-mr').on('click', () => { mr = true; });

$('.link__add-link').on('click', () => { mr = false; });

$('.link__container').on('submit', () => {
  $('.link__add-link').addClass('link__add-link--loading');
  $('.link__input').addClass('link__input--loading');
  link = $.trim($('.link__input').val());
  if (mr) {
    analyzeLink(
      'analyze_link',
      LINK_TYPE,
      {
        link,
        cumulative_criteria: '{}',
        expand_alert_status: true,
      },
      repost?.lead_ad_enabled,
    )
      .then((r) => {
        checkLinkType(link, 'search', r.analyze_type);
        TargetingClient.setAsReady();
        $('.campaign').removeClass('campaign--hidden');
        mr_link = r.market_report_link;
        criteria.market_report_link = [mr_link];
        if (r.alert_status_links.length > 0) {
          const first_link = r.alert_status_links[0];
          r.alert_status_links.splice(0, 1);
          add_link({ link: first_link, sub_creative: '///' }, r.alert_status_links);
        } else {
          alert('sorry, could not expand this link into market report links');
        }
      });
  } else {
    add_link({ link, sub_creative: '///' }, []);
  }

  return false;
});

function add_link(search, more_searches) {
  analyzeLink('analyze_link', 'multi_search',
    {
      link: search.link,
      cumulative_criteria: JSON.stringify(criteria),
    })
    .then((r) => {
      checkLinkType(search.link, 'search', r.analyze_type);
      if (ad_name == '') {
        ad_name = `rg2.me/${r.name}`;
      } else {
        ad_name = `${ad_name},${r.name}`;
      }
      CampaignClient.ad.changeName(ad_name);
      $('.link__hint').slideDown('fast');

      const criteria_count = +r.criteria.count[0].replace('+', '');

      if (criteria_count > 0) {
        past_main_creatives = [];

        // eslint-disable-next-line
        lookup = r.lookup
        criteria = r.cumulative_criteria;
        main_keys = r.cumulative_criteria_keys;

        field_divs = {};
        $('.main-creative__field').trigger('keyup');
        if (repost) {
          create_search_creative(r.original_link, r.description, r.map_url, search.img_src, r.search_keys, r.criteria, search.sub_creative);
        } else {
          create_search_creative(r.original_link, r.description, r.map_url, null, r.search_keys, r.criteria, '///');
        }
        $('.link__input').val('');
      }

      if (more_searches.length > 0) {
        add_link(more_searches[0], more_searches.splice(1));
      } else {
        $('.link__add-link').removeClass('link__add-link--loading');
        $('.link__input').removeClass('link__input--loading');
        TargetingClient.setAsReady();
        $('.main-creative').removeClass('main-creative--disabled');
        $('.image-picker').removeClass('image-picker--disabled');
        $('.button-group').removeClass('button-group--disabled');
        $('.campaign').removeClass('campaign--hidden');
      }

      return getCreatives({
        type: 'multi',
        lookup,
        keys: main_keys,
        key_values: criteria,
        override_lookup,
      });
    })
    .then((main_creatives) => {
      past_main_creatives = main_creatives;
      past_templates = 'none';
      $('.campaign').removeClass('campaign--hidden');

      $('.main-creative__field').trigger('keyup');
      $('.creative-item__first-sub').trigger('keyup');
      $('.creative-item__second-sub').trigger('keyup');
    })
    .catch((err) => {
      console.error('err in multi: ', err);
    });
  $('.link__hint').slideUp('fast');
}

function add_fields(fields, key_values) {
  $('.available-fields__container').empty();
  fields.forEach((key) => {
    const $item = $("<li class='available-fields__item'></li>").html(key);
    field_divs[key] = $item;
    $('.available-fields__container').append($item);
    $item.on('mouseenter', () => {
      $('.available-fields__display-value').html(key_values[key]);
    });
    $item.on('click', () => {
      add_tag(key, null, $active);
    });
  });
}

function upload_finish(status, hash, url, url_128, state) {
  if (status === 1) {
    close_lb();
    searches[state].img_src = url;
    const img = $(`#state_${state}`).attr('src', searches[state].img_src);
    resetSmallWarning(img);
    if (isSmall(img[0])) {
      addSmallWarning(img);
    }
  } else if (status === 'large') {
    close_lb();
    alert('Image Upload Failed: Image Larger Than 8MB. Use a smaller image and try again.');
  } else {
    alert('Image Upload Failed. Try Again');
  }
}

let display_max_prompt = null;
function updated_searches_amt() {
  clearTimeout(display_max_prompt);
  if (searches.length == 1) {
    $('.link__amount').html('1 Search Added').slideDown('fast');
  } else if (searches.length >= 6) {
    $('.link__amount').html(`${searches.length} Searches Added`);
    $('.link__amount').addClass('link__amount--max-reached');
    $('.link__amount').addClass('link__amount--max-disclaimer');
    display_max_prompt = setTimeout(() => {
      $('.link__amount').removeClass('link__amount--max-disclaimer');
    }, 5000);
  } else if (searches.length == 0) {
    $('.link__amount').slideUp('fast');
  } else {
    $('.link__amount').html(`${searches.length} Searches Added`);
    $('.link__amount').removeClass('link__amount--max-reached');
    $('.link__amount').removeClass('link__amount--max-disclaimer');
  }
}

function create_search_creative(original_link, description, img_src, cust_img, search_keys, new_criteria, sub_creative) {
  past_sub_creatives[original_link] = [];
  past_sub_creatives[original_link] = getCreatives({
    type: 'multi_sub',
    keys: search_keys,
    key_values: new_criteria,
    override_lookup,
  });
  const $dom = $(sub_creative_markup);
  const pos = shadow_searches.length;
  const analyzed_image = img_src;

  const $img = $dom.find('img');

  $img[0].onload = (e) => {
    resetSmallWarning($img);
    if (isSmall(e.target)) {
      addSmallWarning($img);
    }
  };

  const search = {
    original_link,
    description,
    img_src: cust_img,
    search_keys,
    criteria: new_criteria,
    ref_line_1: [''],
    ref_line_2: [''],
  };

  if (cust_img) {
    search.img_src = cust_img;
    $img.attr('src', cust_img);
    $dom.find('.creative-item__clear-cust').removeClass('hide');
    $dom.find('.creative-item__cust-img').addClass('hide');
  } else {
    search.img_src = img_src;
    $img.attr('src', img_src);
  }

  searches.push(search);
  shadow_searches.push(false);
  shadow_doms.push($dom);
  updated_searches_amt();
  $img.attr('id', `state_${pos}`);
  $dom.find('.creative-item__clear-cust').on('click', (e) => {
    search.img_src = '';
    $img.attr('src', analyzed_image);
    $(e.target).toggleClass('hide');
    $dom.find('.creative-item__cust-img').toggleClass('hide');
  });
  $dom.find('.creative-item__cust-img').on('click', () => {
    const $img_lb = $(lb_cust_img);
    $img_lb.on('click', (e) => {
      if ($(e.target).hasClass('lightbox')) { close_lb(); }
    });
    let c_imgs = [];
    $('body').append($img_lb);
    jax(
      'get_images',
      {
        account_id,
        creative: JSON.stringify({ template: `${search.ref_line_1}///${search.ref_line_2}` }),
        key_values: JSON.stringify(search.criteria),
        lookup: JSON.stringify(lookup),
        override_lookup: JSON.stringify(override_lookup),
      },
      (r) => {
        c_imgs = [];
        r.forEach((e) => {
          c_imgs.push(e);
          const $i = $(`<div class="c-img__item"><img src="${e.url}"/></div>`);
          $i.appendTo('.c-img__image-gallery');
          $i.find('img').on('click', () => {
            search.img_src = e.url;
            $img.attr('src', search.img_src);
            $dom.find('.creative-item__cust-img').toggleClass('hide');
            $dom.find('.creative-item__clear-cust').toggleClass('hide');
            close_lb();
          });
        });
      },
      () => {},
    );
    $img_lb.find('.c-img__gallery-toggle').on('click', function () {
      $(this).toggleClass('c-img__gallery-toggle--switch');
      $img_lb.find('.c-img__image-gallery').addClass('c-img__image-gallery--wink');
      $img_lb.find('.c-img__image-gallery--wink').on('transitionend webkitTransitionEnd', () => {
        $img_lb.find('.c-img__image-gallery').toggleClass('c-img__image-gallery--2col')
          .off('transitionend webkitTransitionEnd').toggleClass('c-img__image-gallery--wink');
      });
    });
    $img_lb.find('.c-img__file').on('change', function () {
      const send_img = this.files[0];
      const xhr = new XMLHttpRequest();
      const fd = new FormData();
      xhr.open('post', get_server_url('upload_image_new'), true);
      fd.append('account_id', account_id);
      fd.append('state', pos);
      fd.append('image_file', send_img);
      xhr.withCredentials = true;
      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
          const r = JSON.parse(xhr.response);
          upload_finish(r.status, r.hash, r.url, r.url_128, r.state);
          $dom.find('.creative-item__cust-img').toggleClass('hide');
          $dom.find('.creative-item__clear-cust').toggleClass('hide');
        } else if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 422) {
          upload_finish('large');
        } else if (xhr.readyState === 4) {
          upload_finish();
        }
      };
      $img_lb.find('.c-img__upload-row').addClass('c-img__upload-row--uploading');
      xhr.send(fd);
    });
    $img_lb.find('.lightbox__close').on('click', close_lb);
    return false;
  });
  $('.image-picker__creatives-container').append($dom);
  wire_keyup($dom.find('.creative-item__first-sub'), $dom.find('.creative-item__first-preview'), () => ({
    ref_creative: search.ref_line_1,
    key_values: criteria,
  }));
  wire_keyup($dom.find('.creative-item__second-sub'), $dom.find('.creative-item__second-preview'), () => ({
    ref_creative: search.ref_line_2,
    key_values: criteria,
  }));
  $dom.find('.creative-item__original_link-preview').append($('<a></a>').attr('href', criteria.short_link[0]).attr('target', '_blank').text(criteria.short_link[0]));
  $dom.find('.creative-item__description-preview').html(description);
  $dom.find('input.can-add-tags').on('focus', () => {
    if (past_templates == 'sub' && past_templates_original_link == original_link) {
      return;
    }
    past_templates = 'sub';
    past_templates_original_link = original_link;
    add_fields(search_keys, criteria);
    $('.past-templates__container').hide();
    $('.past-templates__container').empty();
    past_sub_creatives[original_link].forEach((v) => {
      const markedup = v.markedup.split('///');
      const template = v.template.split('///');
      const $item = $(`<div class='past-templates__item'><div class='past-templates__row'>${markedup[0]}</div><div class='past-templates__row'>${markedup[1]}</div></div>`);
      $('.past-templates__container').append($item);
      $('.past-templates__container').slideDown('fast');
      $item.on('click', () => {
        $dom.find('.creative-item__first-sub').val(template[0]);
        $dom.find('.creative-item__second-sub').val(template[1]);
        $dom.find('.creative-item__first-sub').focus();
        $dom.find('.creative-item__first-sub').trigger('keyup');
        $dom.find('.creative-item__second-sub').trigger('keyup');
      });
    });
  });
  $dom.find('.creative-item__clear-creative').on('click', () => {
    $dom.find('.creative-item__first-sub').val('').keyup();
    $dom.find('.creative-item__second-sub').val('').keyup();
  });
  $dom.find('.creative-item__use-creative').on('click', () => {
    searches.forEach((e, i) => {
      if (i > pos) {
        /* eslint-disable */
        searches[i].ref_line_1[0] = searches[pos].ref_line_1[0];
        searches[i].ref_line_2[0] = searches[pos].ref_line_2[0];
        /* eslint-enable */
        shadow_doms[i].find('.creative-item__first-sub').val(searches[i].ref_line_1[0]);
        shadow_doms[i].find('.creative-item__second-sub').val(searches[i].ref_line_2[0]);
        shadow_doms[i].find('.creative-item__first-sub').trigger('keyup');
        shadow_doms[i].find('.creative-item__second-sub').trigger('keyup');
      }
    });
  });
  $dom.find('.creative-item__remove-item').on('click', () => {
    searches.splice(pos - shadow_searches.slice(0, pos).filter(v => v).length, 1);
    shadow_searches[pos] = true;
    updated_searches_amt();
    $dom.slideUp('fast', () => { $dom.remove(); });
  });
  const lines = sub_creative.split('///');
  $dom.find('.creative-item__first-sub').val(lines[0]).keyup();
  $dom.find('.creative-item__second-sub').val(lines[1]).keyup();
}

if (link_to_market_reports == true) {
  $('#check-link_to_market_reports').attr('checked', 'checked');
} else {
  $('#check-link_to_market_reports').removeAttr('checked');
}

$('#check-link_to_market_reports').on('change', () => {
  if ($('#check-link_to_market_reports:checked').val()) {
    link_to_market_reports = true;
  } else {
    link_to_market_reports = false;
  }
});

function post_specific_ad() {
  const more_data = {
    landing: false,
    main_creative: ref_main_creative[0],
    searches: JSON.stringify(searches),
    market_report_link: mr_link,
    link_to_market_reports,
  };
  if (searches.length <= 1) {
    alert('Please add at least 2 searches to your post before creating a carousel');
    return false;
  }

  const smallImages = getSmallImages('variable').all;
  if (smallImages.length !== 0 && isInstagramAd()) {
    lb('Some of your images are too small to post on Instagram. Please try a single or multi-link ad with your own images (at least 600px by 600px), or don\'t run this ad on Instagram.', 'fail', null, null, false, false);
    return false;
  }

  post_ad('multi', 'multi', more_data, null, account_id, page_id);
  return false;
}

function on_repost(post) {
  repost = post;
  prompt_leave();
  repost.links.forEach((e, i) => {
    repost_links.push({
      link: e,
      sub_creative: repost.sub_creatives[i],
      img_src: repost.pictures[i],
    });
  });
  add_link(repost_links[0], repost_links.splice(1));
  $('.main-creative__field').val(repost.main_creative).keyup();
}

$('body').on('focus', '.can-add-tags', (e) => {
  $active = $(e.target);
});


function createPreview(previewType) {
  const mainCreativePromise = renderCreative({
    creative_text: ref_main_creative[0],
    key_values: criteria,
    lookup,
    override_lookup,
  }).then(res => res.subbed);

  const searchPromises = [];
  searches.forEach(search => searchPromises.push(createSearchSub(search)));

  return Promise.all([mainCreativePromise, ...searchPromises])
    .then(([mainCreative, ...psubs]) => (
      generateMultiPreview(
        page_id,
        account_id,
        mainCreative,
        psubs,
        [],
        $('#check-end-card').prop('checked'),
        previewType,
      )
    ));
}

function createSearchSub(search) {
  return new Promise((res) => {
    const renderL1 = renderCreative({
      creative_text: search.ref_line_1[0],
      key_values: search.criteria,
      lookup,
      override_lookup,
    });

    const renderL2 = renderCreative({
      creative_text: search.ref_line_2[0],
      key_values: search.criteria,
      lookup,
      override_lookup,
    });

    Promise.all([renderL1, renderL2])
      .then(([r1, r2]) => {
        const title = r1.subbed;
        const description = r2.subbed;

        res({
          img: [search.img_src],
          original_link: search.original_link,
          title: [title],
          description: [description],
        });
      })
      .catch(err => console.error(err));
  });
}

function load_data() {
  render('#agent-landing', <AgentLanding />);
  publishControls('#publish_container', post_specific_ad, LINK_TYPE);
  render('#ad-preview', <AdPreview getPreview={createPreview} validation={validateAtLeastTwoSearches(() => searches)} />);
}

init(on_repost)
  .then(load_data);
